import { Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage'
import ReportPage from './pages/ReportPage'

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm">
        <div className="container py-4">
          <h1 className="text-2xl font-bold text-primary-700">
            🏢 아파트 가격 동향 분석
          </h1>
          <p className="text-sm text-gray-600 mt-1">
            지역별 실거래가 데이터를 분석하고 레포트를 생성합니다
          </p>
        </div>
      </header>

      <main className="container py-8">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/report" element={<ReportPage />} />
        </Routes>
      </main>

      <footer className="bg-white border-t mt-auto">
        <div className="container py-4 text-center text-sm text-gray-500">
          데이터 출처: 국토교통부 부동산 실거래가 공공데이터
        </div>
      </footer>
    </div>
  )
}

export default App